import {Component, Input, OnInit} from '@angular/core';
import {FotoValidacaoService} from 'src/app/api/module/externo/services/photo-validaca/foto.validacao.service';

@Component({
  selector: 'app-documento-final-medsenior',
  templateUrl: './documento-final-medsenior.component.html',
  styleUrls: ['./documento-final-medsenior.component.scss'],
})
export class DocumentoFinalMedseniorComponent implements OnInit {
  @Input() dadosProposta: any;
  @Input() codigoProposta: string = '';
  @Input() dataVigencia: string = '';
  @Input() dataAssinatura: string = '';
  @Input() nomeBeneficiario: string = '';
  @Input() horaAssinatura: string = '';
  @Input() idBeneficiario: string = '';
  @Input() ehDependente: boolean = false;
  @Input() razaoSocialEntidade: string = '';
  @Input() entidadeProposta: string = '';
  @Input() nomeVendedor: string = '';
  @Input() nomeCorretora: string = '';
  @Input() dadosOperadoraCabecalho: any = '';
  @Input() operadoraVM: any = '';

  propostaId = '';
  dadosAvaliacaoSaude: any;
  beneficiarios: any[] = [];
  peso = {titular: ''};
  altura = {titular: ''};

  // Mapeamento de ordem fixa para exibição
  // private readonly ordemExibicao = {
  //   Cpt: 1,
  //   Comum: 2,
  //   CampoLivre: 3,
  //   OrientacaoMedica: 4,
  //   InformacoesAdicionais: 5,
  // };

  constructor(private _fotoValidacaoService: FotoValidacaoService) {}

  ngOnInit(): void {
    this.inicializarDadosProposta();
    this.ehDependente = false;

    if (this.propostaId) {
      this.obterAvaliacaoSaude();
    }
  }

  private inicializarDadosProposta(): void {
    if (this.dadosProposta) {
      this.codigoProposta = this.dadosProposta.code || '';
      this.propostaId = this.dadosProposta.holderProposal?.proposalId;
    }
  }

  obterAvaliacaoSaude(): void {
    this._fotoValidacaoService.obterAvaliacaoSaude(this.propostaId).subscribe({
      next: response => {
        console.log('Avaliação de Saúde:', response);
        this.dadosAvaliacaoSaude = response;
        this.beneficiarios = response.beneficiaries || [];
        this.processarEventosDosBeneficiarios();
      },
      error: err => {
        console.error('Erro ao obter avaliação de saúde:', err);
      },
    });
  }

  private processarEventosDosBeneficiarios(): void {
    this.beneficiarios.forEach(beneficiario => {
      if (beneficiario.declaracaoSaudeFormatada?.length) {
        beneficiario.declaracaoSaudeFormatada.forEach((pergunta: any) => {
          if (pergunta.eventos?.length) {
            pergunta.eventos.forEach((evento: any) => {
              if (evento.eventDate) {
                evento.eventDate = this.formatarData(evento.eventDate);
              }
            });
          }
        });
      }
    });
  }

  formatarData(data: string): string {
    if (!data) return '';
    try {
      const dataObj = new Date(data);
      return dataObj.toLocaleDateString('pt-BR');
    } catch {
      return data;
    }
  }

  formatarDataHora(data: string, hora: string): string {
    if (!data) return '';
    const dataFormatada = this.formatarData(data);
    return hora ? `${dataFormatada} às ${hora}` : dataFormatada;
  }

  /**
   * Obtém perguntas ordenadas para exibição na tabela
   * Inclui perguntas das etapas: DeclaracaoSaude e InformacoesAdicionais
   */
  obterPerguntasOrdenadas(beneficiario: any): any[] {
    if (!beneficiario || !beneficiario.declaracaoSaudeFormatada) {
      return [];
    }

    // Filtra perguntas que têm ordem e são dos tipos corretos
    const perguntas = beneficiario.declaracaoSaudeFormatada.filter(
      (item: any) =>
        item.ordem !== null &&
        item.ordem !== undefined &&
        (item.tipo === 'Comum' || item.tipo === 'CampoLivre' || item.tipo === 'InformacoesAdicionais'),
    );

    // Ordena por ordem numérica (1, 2, 3, ... 20)
    return perguntas.sort((a: any, b: any) => a.ordem - b.ordem);
  }

  /**
   * Filtra perguntas por etapa (mantido para compatibilidade)
   */
  filtrarPerguntasPorEtapa(beneficiario: any, etapa: string): any[] {
    const perguntas = beneficiario?.declaracaoSaudeFormatada;
    if (!perguntas?.length) return [];

    return perguntas
      .filter((item: any) => item.etapa === etapa)
      .sort((a: any, b: any) => (a.ordem || 0) - (b.ordem || 0));
  }

  /**
   * Filtra perguntas por tipo específico
   */
  filtrarPerguntasPorTipo(beneficiario: any, tipo: string): any[] {
    const perguntas = beneficiario?.declaracaoSaudeFormatada;
    if (!perguntas?.length) return [];

    return perguntas
      .filter((item: any) => item.tipo === tipo)
      .sort((a: any, b: any) => (a.ordem || 0) - (b.ordem || 0));
  }

  /**
   * Verifica se existe declaração CPT
   */
  hasCptDeclaracao(beneficiario: any): boolean {
    return this.filtrarPerguntasPorTipo(beneficiario, 'Cpt').length > 0;
  }

  /**
   * Verifica se existe orientação médica
   */
  hasOrientacaoMedica(beneficiario: any): boolean {
    return this.filtrarPerguntasPorTipo(beneficiario, 'OrientacaoMedica').length > 0;
  }

  /**
   * Retorna doenças declaradas com SIM
   */
  getDoencasDeclaradas(beneficiario: any): any[] {
    const perguntas = beneficiario?.declaracaoSaudeFormatada;
    if (!perguntas?.length) return [];

    return perguntas.filter(
      (item: any) => item.etapa === 'DeclaracaoSaude' && item.tipo === 'Comum' && item.seAplica === true,
    );
  }

  /**
   * Obtém texto da resposta formatado
   */
  obterRespostaTexto(item: any): string {
    if (!item.seAplica) return 'NÃO';
    return 'SIM';
  }

  ordenarPerguntasPorTipo(perguntas: any[]): any[] {
    if (!perguntas || !Array.isArray(perguntas)) {
      return [];
    }
    const ordemTipo: any = {
      Cpt: 1,
      Comum: 2,
      CampoLivre: 3,
      OrientacaoMedica: 4,
      InformacoesAdicionais: 5,
    };

    return perguntas.sort((a, b) => {
      const ordemA = ordemTipo[a.tipo] || 999;
      const ordemB = ordemTipo[b.tipo] || 999;
      if (ordemA !== ordemB) {
        return ordemA - ordemB;
      }
      return a.ordem - b.ordem;
    });
  }

  temCidsSelecionados(beneficiario: any): boolean {
    if (!beneficiario || !beneficiario.declaracaoSaudeFormatada) {
      return false;
    }
    return beneficiario.declaracaoSaudeFormatada.some(
      (item: any) => item.cidsSelecionados && item.cidsSelecionados.length > 0,
    );
  }

  // ==================== MÉTODOS PARA PESO E ALTURA ====================

  get beneficiarioTitular(): any {
    if (!this.beneficiarios || this.beneficiarios.length === 0) {
      return null;
    }
    return this.beneficiarios.find((b: any) => b.dependentProposalId === null) || this.beneficiarios[0];
  }

  get dependentesList(): any[] {
    if (!this.beneficiarios || this.beneficiarios.length === 0) {
      return [];
    }
    return this.beneficiarios.filter((b: any) => b.dependentProposalId !== null);
  }

  obterPesoPorBeneficiario(beneficiario: any): string {
    if (!beneficiario || !beneficiario.peso) return '';
    return beneficiario.peso.toString();
  }

  obterAlturaPorBeneficiario(beneficiario: any): string {
    if (!beneficiario || !beneficiario.altura) return '';
    return beneficiario.altura.toString();
  }

  temDoencaDeclarada(beneficiario: any): boolean {
    if (!beneficiario || !beneficiario.declaracaoSaudeFormatada) {
      return false;
    }

    return beneficiario.declaracaoSaudeFormatada.some(
      (item: any) => item.etapa === 'DeclaracaoSaude' && item.seAplica === true,
    );
  }

  obterPatologias(beneficiario: any): string {
    if (!beneficiario || !beneficiario.declaracaoSaudeFormatada) {
      return '';
    }

    const doencas = beneficiario.declaracaoSaudeFormatada
      .filter((item: any) => item.etapa === 'DeclaracaoSaude' && item.seAplica === true && item.tipo === 'Comum')
      .map((item: any) => {
        let texto = item.pergunta;
        if (item.detalhamento) {
          texto += ` (${item.detalhamento})`;
        }
        if (item.cidsSelecionados && item.cidsSelecionados.length > 0) {
          const cids = item.cidsSelecionados.map((cid: any) => cid.cid).join(', ');
          texto += ` [CID: ${cids}]`;
        }
        return texto;
      });

    return doencas.join('; ');
  }
  get colunasDependentes(): any[] {
    // Se não houver dependentes, retorna um array com 1 item vazio para exibir "Dep 1"
    if (!this.dependentesList || this.dependentesList.length === 0) {
      return [{}];
    }
    return this.dependentesList;
  }
}
